import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchGetNewbuildingValuationBlockWeb,
  TGetNewbuildingValuationBlockWebRequest,
  TGetNewbuildingValuationBlockWebResponse,
} from '../../repositories/newbuilding-estimate/v2/get-newbuilding-valuation-block-web';
import { IApplicationContext } from '../../types/applicationContext';
import { INewbuildingValuationResponse } from '../../repositories/newbuilding-estimate/entities/newbuilding_prices_and_deals/NewbuildingValuationResponse';

interface IParams extends TGetNewbuildingValuationBlockWebRequest {
  context: IApplicationContext;
}

export async function fetchRealtyValuation({
  context,
  newbuildingId,
  pricesFilters,
  salesFilters,
}: IParams): Promise<INewbuildingValuationResponse> {
  try {
    const res: TGetNewbuildingValuationBlockWebResponse = await fetchGetNewbuildingValuationBlockWeb({
      httpApi: context.httpApi,
      parameters: { newbuildingId, pricesFilters, salesFilters },
    });

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: res.statusCode,
        domain: 'fetchRealtyValuation.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    }

    return res.response;
  } catch (e) {
    if (!HttpBadStatusCodeError.is(e)) {
      context.logger.error(e);
    } else {
      context.logger.debug(e.message, { details: e.printDetails() });
    }
  }

  return {};
}
